import { z } from "zod";

const passwordSchema = z
  .string("Campo obrigatório!")
  .min(8, "A senha deve ter no mínimo 8 caracteres!");
// .regex(/[A-Z]/, "Deve conter pelo menos uma letra maiúscula!")
// .regex(/[a-z]/, "Deve conter pelo menos uma letra minúscula!")
// .regex(/[0-9]/, "Deve conter pelo menos um número!")
// .regex(/[^A-Za-z0-9]/, "Deve conter pelo menos um caractere especial!");

export const loginSchema = z.object({
  email: z.email("E-mail inválido!"),
  password: passwordSchema,
});

export const registerSchema = z.object({
  name: z.string().min(1, "Campo obrigatório!"),
  email: z.email("E-mail inválido!"),
  password: passwordSchema,
});

/** Troca obrigatória após o ADMIN redefinir a senha: não pede a atual (era a temporária). */
export const changePasswordSchema = z.object({
  newPassword: passwordSchema,
});

export type RegisterSchema = z.infer<typeof registerSchema>;
export type ChangePasswordSchema = z.infer<typeof changePasswordSchema>;
export type LoginSchema = z.infer<typeof loginSchema>;
